import { LookupsService } from "./lookups/lookups.service";
import { ProductsService } from "./products/products.services";
import { CasesService } from "./cases/cases.service";
import { RolesService } from "./roles.services";
import { RiskLevelsService } from "./riskLevels.services";
import { CoursesService } from "./courses.services";
import { LangService } from "./lang/lang.service";
import { CommonService } from "./common/common.service";

class Services {
  lang = new LangService();
  common = new CommonService();
  products = new ProductsService();
  lookups = new LookupsService();
  cases = new CasesService();
  roles = new RolesService();
  riskLevels = new RiskLevelsService();
  courses = new CoursesService();
}

export const services = new Services();
